import { Linkedin, Github } from "lucide-react";

const FOUNDER = "https://customer-assets-eiarnc6j.emergentagent.net/job_866b050f-6fe1-4fe7-bfc5-3735f1a9bc75/artifacts/oghmfznn_IMG_5613.jpeg";

const TEAM = [
  { name: "Lead Backend Engineer", role: "Golang · Microservices", initials: "GO" },
  { name: "Database & Cache Architect", role: "MySQL · Redis tuning", initials: "DB" },
  { name: "Platform / DevOps", role: "Docker · Kubernetes", initials: "K8" },
];

export const Teams = () => (
  <section id="teams" className="py-24 px-4 sm:px-6 lg:px-8 bg-slate-950/40 border-y border-slate-800/60">
    <div className="max-w-7xl mx-auto">
      <div className="max-w-2xl mb-14">
        <span className="text-xs font-mono uppercase tracking-widest text-emerald-400">Teams</span>
        <h2 className="mt-3 font-display text-3xl lg:text-4xl font-bold tracking-tight text-slate-100">
          The people behind the engine
        </h2>
        <p className="mt-4 text-slate-400 leading-relaxed">
          A collaborative crew that pairs deep backend craft with a positive, problem-solving culture — regular social events and direct access to customers and colleagues.
        </p>
      </div>

      <div className="grid lg:grid-cols-3 gap-8 items-start">
        <div className="lg:col-span-1 glass rounded-2xl border border-slate-800 overflow-hidden shadow-2xl shadow-black/50 glow-emerald" data-testid="founder-card">
          <div className="relative">
            <img src={FOUNDER} alt="Founder &amp; CEO" loading="lazy"
              className="w-full aspect-[4/5] object-cover object-top bg-slate-900" />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-transparent pointer-events-none" />
            <span className="absolute top-4 left-4 text-[10px] font-mono uppercase tracking-widest text-emerald-400 border border-emerald-500/40 bg-slate-950/70 rounded-full px-3 py-1">
              Founder & CEO
            </span>
          </div>
          <div className="p-6">
            <h3 className="font-display text-xl font-semibold text-white">Wiwi</h3>
            <p className="text-sm text-emerald-400 font-mono mt-0.5">Founder &amp; Chief Executive Officer</p>
            <p className="mt-3 text-sm text-slate-400 leading-relaxed">
              Driving Wiwi's mission to make elite game backend engineering accessible to every studio through an intelligent digital twin.
            </p>
            <div className="mt-5 flex items-center gap-3 text-slate-500">
              <Linkedin className="w-4 h-4 hover:text-emerald-400 cursor-pointer transition-colors" />
              <Github className="w-4 h-4 hover:text-emerald-400 cursor-pointer transition-colors" />
            </div>
          </div>
        </div>

        <div className="lg:col-span-2 grid sm:grid-cols-3 gap-6">
          {TEAM.map((m, i) => (
            <div key={m.name} data-testid={`team-member-${i}`}
              className="glass rounded-xl border border-slate-800 p-6 hover:border-emerald-500/40 transition-colors">
              <div className="w-14 h-14 rounded-xl bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center font-display font-bold text-emerald-400 text-lg">
                {m.initials}
              </div>
              <h4 className="mt-4 text-slate-100 font-medium">{m.name}</h4>
              <p className="text-xs text-slate-500 font-mono mt-1">{m.role}</p>
            </div>
          ))}
          <div className="sm:col-span-3 glass rounded-xl border border-slate-800 p-6 flex items-center justify-between flex-wrap gap-4">
            <div>
              <h4 className="text-slate-100 font-medium">Join a collaborative, people-first team</h4>
              <p className="text-sm text-slate-500 mt-1">Cross-functional work with designers, PMs and stakeholders.</p>
            </div>
            <span className="text-xs font-mono text-emerald-400 border border-emerald-500/30 rounded-full px-4 py-2">We're hiring engineers</span>
          </div>
        </div>
      </div>
    </div>
  </section>
);
